export const HOVER_OVER_VIDEO_DURATION = 2000
